import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IInvoicingGroup } from "../../utils/types/models";

export default createEntityReducer<IInvoicingGroup>(Endpoint.InvoicingGroups, Endpoint.InvoicingGroupsList);
